import axios from "axios";
import store from "../redux/store";

import endpoints from "./endpoints";
import { refreshAuthToken } from "../features/auth/slices/authSlice";

// Créer une instance d'axios
const axiosInstance = axios.create({
  baseURL: endpoints.baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercepteur de requête
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const language = state.languageSlice.language;
    const token = state.authSlice.token;

    if (language) {
      config.headers["Accept-Language"] = language;
    }
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse
axiosInstance.interceptors.response.use(
  response => response, // Si la réponse est correcte, la retourner.
  async (error) => {
    const originalRequest = error.config;
    const state = store.getState();
    const refreshToken = state.authSlice.refreshToken;
    const token = state.authSlice.token; // Récupérer le token actuel

    if (error.response?.status === 401 && refreshToken) {
      if (token) { // Vérifier que le token n'est pas null
        // Si le statut est 401 et que le refreshToken est disponible, on essaie de rafraîchir le token.
        try {
          // Appeler l'action pour rafraîchir le token
          const response = await store.dispatch(
            refreshAuthToken({ AccessToken: token, RefreshToken: refreshToken })
          ).unwrap();

          // Mettre à jour les headers avec le nouveau token
          originalRequest.headers["Authorization"] = `Bearer ${response.token}`;

          // Refaire la requête avec le nouveau token
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          // Si l'échec du rafraîchissement du token, vous pouvez déconnecter l'utilisateur, etc.
          return Promise.reject(refreshError);
        }
      } else {
        // Token est null, déconnecter l'utilisateur ou rediriger vers la page de connexion
        console.error("No token found, redirecting to login...");
        // Optionnel : Déconnecter l'utilisateur
        // store.dispatch(logout());
        return Promise.reject("No valid token found");
      }
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;
